// Client logos for the trusted-by wine band.
// To add real logos: drop PNG/SVG into /app/frontend/public/clients/ and add an entry below.
export const CLIENTS = [
  { name: "Makro", type: "image", src: "/clients/makro.png" },
  { name: "Alcampo", type: "image", src: "/clients/alcampo.png" },
  { name: "Mittemeer", type: "image", src: "/clients/mittemeer.png" },
];
